<template>
  <head>
    <title>ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH</title>
  </head>
  <router-view></router-view>
</template>


